import { DialogAccessCredentials, FormStage } from 'BreetComponents';
import { type IUseAccessCredentialsRequest, OTPLENGTH } from 'BreetHelpers';
import { useAccessCredentials, useFormStage } from 'BreetHooks';
import { useCallback } from 'react';

import ConfirmResetAction from './ConfirmResetAction';
import type { IPinStepGuard, PREPINRESETSTAGE } from './PinManagement.helpers';

const PinStepGuard = ({ children, mode, setOTP }: IPinStepGuard) => {
	const { isStageActive, navigator } = useFormStage<PREPINRESETSTAGE>(mode !== 'reset' ? 'children' : 'confirm-reset', [
		'confirm-reset',
		'verify-otp',
		'children',
	]);

	const onVerifyOtp = useCallback(
		(data?: IUseAccessCredentialsRequest) => {
			if (data?.code) {
				setOTP(data.code);
				navigator.goTo('children')();
			}
		},
		[navigator, setOTP]
	);

	const { component, handleVerification } = useAccessCredentials({
		id: 'reset-pin',
		mode: 'otp',
		submitRequest: onVerifyOtp,
		description: `Enter the ${OTPLENGTH}-digit OTP sent to the email associated with this account.`,
		title: 'Enter OTP for Verification',
		type: 'collect',
		render: (props) => <DialogAccessCredentials {...props} />,
	});

	const handleConfirm = useCallback(() => {
		handleVerification();
		navigator.goTo(mode === 'reset' ? 'children' : 'verify-otp')();
	}, [handleVerification, mode, navigator]);

	return (
		<>
			<FormStage hide={!isStageActive('confirm-reset')}>
				<ConfirmResetAction
					confirmAction={handleConfirm}
					title='Reset Transaction PIN'
					description='To reset your PIN, a code will be sent to the email associated with this account.'
				/>
			</FormStage>

			<FormStage hide={!isStageActive('verify-otp')}>{component}</FormStage>

			<FormStage hide={!isStageActive('children')}>{children}</FormStage>
		</>
	);
};

export default PinStepGuard;
